module.exports = __webpack_public_path__ + "media/images/gallery/pn_off-c13cf6479f6a88310779e3acb2194156.gif";